export function registerEditorCommands (editor, { onFormat, onSave }) {
  const commands = [
    {
      name: 'smartEndpointSave',
      bindKey: { win: 'Ctrl-S', mac: 'Command-S' },
      exec: () => { if (onSave) onSave() },
      readOnly: false
    },
    {
      name: 'smartEndpointFormat',
      bindKey: { win: 'Shift-Alt-F', mac: 'Shift-Option-F' },
      exec: async () => { if (onFormat) await onFormat() },
      readOnly: false
    },
    {
      name: 'smartEndpointFind',
      bindKey: { win: 'Ctrl-F', mac: 'Command-F' },
      exec: loadedEditor => loadedEditor.execCommand('find'),
      readOnly: true
    },
    {
      name: 'smartEndpointReplace',
      bindKey: { win: 'Ctrl-H', mac: 'Command-Alt-F' },
      exec: loadedEditor => loadedEditor.execCommand('replace'),
      readOnly: false
    },
    {
      name: 'smartEndpointFindNext',
      bindKey: { win: 'Ctrl-G', mac: 'Command-G' },
      exec: loadedEditor => loadedEditor.findNext(),
      readOnly: true
    },
    {
      name: 'smartEndpointFindPrevious',
      bindKey: { win: 'Ctrl-Shift-G', mac: 'Command-Shift-G' },
      exec: loadedEditor => loadedEditor.findPrevious(),
      readOnly: true
    },
    {
      name: 'smartEndpointSelectNextOccurrence',
      bindKey: { win: 'Ctrl-D', mac: 'Command-D' },
      exec: loadedEditor => loadedEditor.execCommand('selectMoreAfter'),
      readOnly: true
    },
    {
      name: 'smartEndpointAddCursorAbove',
      bindKey: { win: 'Ctrl-Alt-Up', mac: 'Command-Option-Up' },
      exec: loadedEditor => loadedEditor.execCommand('addCursorAbove'),
      readOnly: true
    },
    {
      name: 'smartEndpointAddCursorBelow',
      bindKey: { win: 'Ctrl-Alt-Down', mac: 'Command-Option-Down' },
      exec: loadedEditor => loadedEditor.execCommand('addCursorBelow'),
      readOnly: true
    },
    {
      name: 'smartEndpointUndo',
      bindKey: { win: 'Ctrl-Z', mac: 'Command-Z' },
      exec: loadedEditor => loadedEditor.undo(),
      readOnly: false
    },
    {
      name: 'smartEndpointRedo',
      bindKey: { win: 'Ctrl-Y|Ctrl-Shift-Z', mac: 'Command-Shift-Z' },
      exec: loadedEditor => loadedEditor.redo(),
      readOnly: false
    }
  ]

  commands.forEach(command => {
    editor.commands.addCommand(command)
  })
}
